/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

export function siteCookieControls() {
  // Wait for DOM to be ready
  $(document).ready(function() {

    // Check if the element exists
    if ($('.oliviaAlert').length === 0) {
      // console.log('oliviaAlert element not found on this page');
      return;
    }

    // console.log('Cookie check:', getCookie('olivia-alert')); // Debug

    if (!getCookie('olivia-alert')) {
      // console.log('No cookie found, will show alert'); // Debug
      setTimeout(function () {
        $('.oliviaAlert').addClass('open');
        // console.log('Added open class'); // Debug
      }, 2000);
    } else {
      // console.log('Cookie exists, not showing alert'); // Debug
    }

    $('.oliviaAlert__close, .oliviaAlert').on('click tap', function () {
      $('.oliviaAlert').removeClass('open');
      setCookie('olivia-alert', 'Do not show the Olivia alert if someone has manually closed it.', 3);
    });

  });
}

